import { HttpRequest, HttpMethod } from "./http";

// Storefront home-content CMS (issue #185 / spec 2026-07-16-storefront-home-redesign §4.2).
// BO admin editor for the redesigned mdf-www homepage. Content lives in the App PG
// (mdf_member) and is written via MemberDB() on the BO side — no cross-DB sync.
class HomeContentProvider extends HttpRequest {
    // Full raw config for the editor: { data: { sections: {...12...}, meta: {...} } }.
    // Image keys are resolved to *_url preview fields; bestsellers are raw product_ids
    // (the picker resolves labels itself).
    get() {
        return this.request(HttpMethod.Get, "/api/v1/bo/storefront/home");
    }

    // Save one section. `section` is one of the 12 section names; `payload` is that
    // section's raw JSON document (image fields carry *_key only, never full URLs).
    updateSection(section, payload) {
        return this.request(HttpMethod.Put, `/api/v1/bo/storefront/home/${section}`, payload);
    }
}

export default HomeContentProvider;
